/**
 * 通用路由
 */
export default [
  { // 核销统计
    path: '/writeoffstatistics',
    component: () => import('@/views/database/writeoffStatistics.vue'),
    children:
      [],
  },
  { // 每日核销
    path: '/writeoffday',
    component: () => import('@/views/database/writeoffDay.vue'),
    children:
      [],
  },
];
